import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { closeAll } from '@ivy/fts/showDiv';
import { env } from '@ivy/fts/envInfo/envInfo';
import openApp from '@ivy/fts/openApp';
import * as api from '../api';
import config from '../../../config';
import { requirePost, addStatistics } from '../api';
let StatusDialog = class StatusDialog extends Vue {
    constructor() {
        super(...arguments);
        this.status1 = require('../imgs/status-not-start.png');
        this.status2 = require('../imgs/status-team-success.png');
        this.status5 = require('../imgs/status-end-or-old.png');
        this.status6 = require('../imgs/status-team-fulled.png');
        this.status_text = '';
        this.intro_text = '';
        this.hideBtn = false;
        this.doubleBtn = false;
        this.btn_text = '';
        this.btn_text2 = '';
        this.topImg = true;
        this.showClose = false;
        this.wrapperClass = 'status-wrapper';
        this.appMapper = {
            ivydad: '常青藤爸爸',
            ivydad_eduai: '小小常爱学习',
            ivydad_literacy: '小小常爱识字',
        };
        this.appName = '';
        this.isRequest = false;
        this.ios10Shadow = false;
        this.langPress = false;
        this.tipTxt = '';
    }
    async mounted() {
        await env.init();
        if (env.type === 'ivydad') {
            let info = await env.getInfo();
            this.appName = info.publicParams.app_name;
        }
        switch (this.status) {
            case 1:
                this.status_text = '活动未开始';
                this.intro_text = `开始时间<br>${this.begin_time}<br>敬请期待～`;
                this.status_logo = this.status1;
                break;
            case 2:
                this.status_text = '恭喜！仅剩一步成功加入组队';
                this.intro_text = `使用注册手机号登录“${this.appMapper[this.shareAppName]}App”<br>进入活动页面加入组队`;
                this.btn_text = '立即登录App加入';
                this.status_logo = this.status2;
                this.showClose = true;
                break;
            case 3:
                this.status_text = '恭喜组队成功';
                this.intro_text = '点击下方按钮填写/修改收货地址吧～';
                this.btn_text = '填写/修改收货地址';
                this.status_logo = this.status2;
                break;
            case 4:
                this.status_text = '恭喜组队成功';
                this.intro_text = this.success_desc;
                this.btn_text = '我知道啦';
                this.status_logo = this.status2;
                break;
            case 5:
                this.status_text = '您已是常爸老用户';
                this.intro_text =
                    '老用户无法加入其他用户发起的组队，<br>立即发起自己的组队吧～';
                this.btn_text = '立即发起组队';
                this.status_logo = this.status5;
                break;
            case 6:
                this.status_text = '组队名额已满';
                this.intro_text =
                    '很遗憾，本队伍的组队名额已满，<br>立即发起自己的组队吧～';
                this.btn_text = '立即发起组队';
                this.status_logo = this.status6;
                this.showClose = true;
                break;
            case 7:
                this.status_text = '活动已结束';
                this.intro_text = '很遗憾活动已结束<br>敬请期待下期活动';
                this.btn_text = '我知道啦';
                this.status_logo = this.status6;
                break;
            case 8:
                this.status_text = '很遗憾！组队失败';
                this.intro_text = '点击下方按钮重新发起组队吧';
                this.btn_text = '重新发起组队';
                this.status_logo = this.status5;
                break;
            case 9:
                this.status_text = '恭喜！仅剩一步成功加入组队';
                this.intro_text = `使用注册手机号登录“${this.appMapper[this.shareAppName]}”App<br>进入活动页面加入组队`;
                this.btn_text = '我知道啦';
                this.status_logo = this.status2;
                break;
            case 10:
                this.status_text = '关注“常青藤爸爸学堂”公众号</br>实时获取组队进度';
                this.status_logo = require('../imgs/guide-service.png');
                if (env.type === 'wx') {
                    this.wrapperClass = 'status-wrapper10-wx2';
                    this.hideBtn = true;
                    this.showClose = true;
                    this.status_logo = this.qr_code_url;
                    this.status_text = '关注“常青藤爸爸学堂”公众号</br>实时获取组队进度';
                    this.intro_text = '长按下方二维码';
                    this.topImg = false;
                    this.langPress = true;
                }
                else if (env.type === 'ivydad') {
                    this.wrapperClass = 'status-wrapper10-app';
                    this.showClose = true;
                    this.doubleBtn = false;
                    this.intro_text =
                        '1、点击【复制公众号名称】</br>2、微信搜索并关注公众号';
                    this.btn_text = '复制公众号名称';
                }
                break;
            case 11:
                this.status_text = '您已有该奖品权限';
                this.intro_text = `请关注其他组队活动`;
                this.btn_text = '我知道啦';
                this.status_logo = this.status1;
                break;
            case 12:
                this.status_text = '您已登录过APP';
                this.intro_text = `您已登录过“${this.appMapper[this.shareAppName]}”APP，</br>无法加入，立即发起自己的组队吧～`;
                this.btn_text = '立即发起组队';
                this.status_logo = this.status1;
                break;
            case 13:
                this.wrapperClass = 'status-wrapper13';
                this.intro_text = '您当前已有组队活动进行中<br>请完成后再来参加哦~';
                this.btn_text = '知道了';
                this.status_logo = this.status5;
                break;
            case 14:
                this.wrapperClass = 'status-wrapper14';
                this.tipTxt =
                    '*队长专属奖品是您发起组队后的奖励，每个组队活动队长只获得一次';
                this.status_text = '成功获得队长专属奖品';
                this.intro_text = `您的队长专属奖品[${this.publish_reward_name}]，</br>已发放到您的账户~`;
                this.btn_text = '我知道了';
                this.status_logo = this.status2;
                break;
            default:
                break;
        }
    }
    async handlerAction(btn2 = false) {
        switch (this.status) {
            case 2:
                await this.openSpecifyApp();
                break;
            case 3:
                this.goAddress();
                break;
            case 4:
                closeAll();
                break;
            case 5:
                if (this.isRequest)
                    return;
                this.isRequest = true;
                try {
                    // 埋点-发起组队按钮的点击
                    await addStatistics({
                        activity_id: this.activityId,
                        event_type: 'Click_ATeam_xszd',
                        p1: this.child_id,
                        p2: env.type === 'ivydad' ? this.appName : 'h5',
                    });
                }
                catch { }
                await this.publishMyTeam();
                break;
            case 6:
                if (this.isRequest)
                    return;
                this.isRequest = true;
                try {
                    // 埋点-发起组队按钮的点击
                    await addStatistics({
                        activity_id: this.activityId,
                        event_type: 'Click_ATeam_xszd',
                        p1: this.child_id,
                        p2: env.type === 'ivydad' ? this.appName : 'h5',
                    });
                }
                catch { }
                await this.publishMyTeam();
                break;
            case 7:
                closeAll();
                break;
            case 8:
                if (this.isRequest)
                    return;
                this.isRequest = true;
                try {
                    // 埋点-重新发起组队按钮的点击
                    await addStatistics({
                        activity_id: this.activityId,
                        event_type: 'Click_NewTeam_xszd',
                        p1: this.child_id,
                        p2: env.type === 'ivydad' ? this.appName : 'h5',
                    });
                }
                catch { }
                await this.publishMyTeam();
                break;
            case 9:
                closeAll();
                break;
            case 10:
                if (this.doubleBtn && btn2) {
                    this.wrapperClass = 'status-wrapper10-wx2';
                    this.hideBtn = true;
                    this.showClose = true;
                    this.status_logo = this.qr_code_url;
                    this.status_text = '关注“常青藤爸爸学堂”公众号</br>实时获取组队进度';
                    this.intro_text = '长按下方二维码';
                    this.topImg = false;
                    this.langPress = true;
                }
                else {
                    if (env.type === 'wx') {
                        closeAll();
                    }
                    else if (env.type === 'ivydad') {
                        this.$copyText('常青藤爸爸学堂');
                        this.$Toast('复制成功');
                        try {
                            // 埋点-复制公众号名称按钮的点击
                            await addStatistics({
                                activity_id: this.activityId,
                                event_type: 'Click_DuplicateAccount_xszd',
                                p1: this.child_id,
                                p2: this.appName,
                                p3: this.userType,
                            });
                        }
                        catch { }
                    }
                }
                break;
            case 11:
                closeAll();
                break;
            case 12:
                if (this.isRequest)
                    return;
                this.isRequest = true;
                try {
                    // 埋点-重新发起组队按钮的点击
                    await addStatistics({
                        activity_id: this.activityId,
                        event_type: 'Click_ATeam_xszd',
                        p1: this.child_id,
                        p2: env.type === 'ivydad' ? this.appName : 'h5',
                    });
                }
                catch { }
                await this.publishMyTeam();
                break;
            case 13:
            case 14:
                closeAll();
                break;
            default:
                break;
        }
    }
    async publishMyTeam() {
        await env.init();
        if (!(await env.getIsLogin())) {
            this.ios10Shadow = true;
            return await env.login();
        }
        else {
            if (this.auth)
                return this.$Toast('您已有该课程权限请关注其他组队活动');
            const { data: res } = await requirePost('/api/activity/appActivity/teamActivity/publishTeam', {
                team_activity_id: this.child_id,
                app_name: env.type === 'ivydad' ? this.appName : 'h5',
            }, {
                disableLoading: false,
                disableAlert: false,
                disableNetWorkError: true,
            });
            if (res.team_id) {
                // window.location.reload()
                this.$router.push({
                    path: `/teamFree/teamDetail`,
                    query: {
                        activityId: this.activityId,
                        id: this.child_id,
                        team_id: res.team_id,
                        _hideShareButton: '1',
                    },
                });
                window.location.reload();
            }
            else {
                this.isRequest = false;
                this.$Toast(res.message);
            }
        }
    }
    // ios10 env.login()页面不刷新问题
    async ios10ShadowClick() {
        window.location.reload();
    }
    // 打开指定的app
    async openSpecifyApp() {
        if (this.shareAppName === 'ivydad') {
            await openApp();
        }
        else if (this.shareAppName === 'ivydad_eduai') {
            await openApp('ivydadReadtool://', 'eduai');
        }
        else if (this.shareAppName === 'ivydad_literacy') {
            await openApp('ivydadReadtool://', 'literacy');
        }
    }
    async goAddress() {
        let resUrl = new api.ChangeURLArg(window.location.href);
        let href = resUrl
            .removeQuery('receiver_id')
            .removeQuery('ignoreStastics')
            .removeQuery('_hideShareButton')
            .getResult();
        const host = config.env === 'production'
            ? `https://m.ivydad.com/`
            : `http://m.ivydad.com.cn/`;
        let token = await env.getToken();
        let cur_url = `${href}${href.includes('?') ? '&' : '?'}ignoreStastics=1`;
        let receiverId = this.receiverId;
        window.location.href = `${host}center/address/addressList?mode=select&receiverId=${receiverId}&_hideShareButton=1&token=${token}&redirect=${encodeURIComponent(cur_url)}`;
    }
    async touchstart() {
        if (this.langPress) {
            clearTimeout(this.startTime);
            this.startTime = setTimeout(async () => {
                try {
                    // 埋点-扫描海报二维码
                    await addStatistics({
                        activity_id: this.activityId,
                        event_type: 'RecognizeAccount_xszd',
                        p1: this.child_id,
                        p2: env.type === 'ivydad' ? this.appName : 'h5',
                        p3: this.userType,
                    });
                }
                catch { }
            }, 1000);
        }
    }
    touchmove() {
        if (this.langPress) {
            clearTimeout(this.startTime);
        }
    }
    touchend() {
        if (this.langPress) {
            clearTimeout(this.startTime);
        }
    }
    close() {
        closeAll();
    }
};
tslib_1.__decorate([
    Prop()
], StatusDialog.prototype, "activityId", void 0);
tslib_1.__decorate([
    Prop({ default: '' })
], StatusDialog.prototype, "begin_time", void 0);
tslib_1.__decorate([
    Prop({ default: 1 })
], StatusDialog.prototype, "status", void 0);
tslib_1.__decorate([
    Prop()
], StatusDialog.prototype, "receiverId", void 0);
tslib_1.__decorate([
    Prop()
], StatusDialog.prototype, "child_id", void 0);
tslib_1.__decorate([
    Prop()
], StatusDialog.prototype, "shareAppName", void 0);
tslib_1.__decorate([
    Prop()
], StatusDialog.prototype, "success_desc", void 0);
tslib_1.__decorate([
    Prop()
], StatusDialog.prototype, "userType", void 0);
tslib_1.__decorate([
    Prop()
], StatusDialog.prototype, "qr_code_url", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], StatusDialog.prototype, "auth", void 0);
tslib_1.__decorate([
    Prop()
], StatusDialog.prototype, "publish_reward_name", void 0);
StatusDialog = tslib_1.__decorate([
    Component({})
], StatusDialog);
export default StatusDialog;
